<template>
  <b-container class="highlight-container">
    <!-- <router-link to="/"><i class="fas fa-times btn--close"></i></router-link> -->
    <router-link :to="`/${form.sourceQuery}`"
      ><i class="fas fa-times btn--close"></i
    ></router-link>
    <b-img
      src="/img/icons/community-title.svg"
      class="community-logo"
      alt="New Seaton"
    />
    <b-row>
      <b-col md="12" class="text-center px-0">
        <h2 class="text--extrabold mb-10 flexFont">Built From The Ground Up</h2>
        <p v-scroll-reveal>
          At New Seaton, we have that new home feeling throughout
          <br class="d-none d-md-block" />
          our whole community. Every detail of this community has been planned
          <br class="d-none d-sm-block" />
          to make your life easier.
        </p>
        <!-- <div class="image-wrapper" v-scroll-reveal="{delay: 150}">
          <b-img src="/img/white-spacer.png" fluid center alt="New Seaton Parks" />
        </div> -->
      </b-col>
    </b-row>

    <b-row class="background--white slider-br">
      <b-col lg="12" class="mb-35">
        <slick ref="slick" :options="slickOptions">
          <!-- <brookfield-newrelease-banner /> -->
          <!-- <a data-fancybox="gallery" href="/files/NewSeaton_WebBannerBrook_092519-min.pdf"><b-img src="/img/Towerhill_NewSeaton_WebBannerBrook_071519 2-03.jpg" fluid center  /></a>
          <a data-fancybox="gallery" href="/files/Brook_NewSeaton_DirectionalHandout_050119.pdf"><b-img src="/img/Brookfield-Modelhomes.jpg" fluid center  /></a>    -->
        </slick>
      </b-col>
    </b-row>
    <nuxt-link :to="`/register/${form.sourceQuery}`">
      <b-img
        src="img/Brook_NewSeaton_WebBannerBug_100520.jpg"
        fluid
        style="background-color: #fff;"
        alt="Brookfield Townhome rendering"
      ></b-img>
    </nuxt-link>

    <div class="home-container background--white pt-5">
      <b-row class="site-logo" v-scroll-reveal="{ delay: 150 }">
        <b-col md="8" sm="6" class="mb-2">
          <b-img src="/img/brookfield-logo.png" fluid alt="Brookfield" />
        </b-col>
        <b-col md="4" sm="6" class="text-center">
          <br />
          <h4>View other builders</h4>
          <button class="black-button">
            <nuxt-link to="/aspenridgeHomes">
              <!-- <nuxt-link :to="`/aspenridgeHomes${form.sourceQuery}`"> -->
              <b-img
                class="black-button-img"
                src="/img/icons/button-logo-aspenridge.png"
                fluid
                alt="Aspen Ridge"
              />
            </nuxt-link>
          </button>
          <button class="black-button">
            <nuxt-link to="/towerhillHomes">
              <!-- <nuxt-link :to="`/towerhillHomes${form.sourceQuery}`"> -->
              <b-img
                class="black-button-img"
                src="/img/icons/button-logo-towerhill.png"
                fluid
                alt="Tower Hill"
              />
            </nuxt-link>
          </button>
          <!-- <a href="/files/APS&Buyers_Guide.pdf" target="_blank">
              <button class="red-button">
                Download Brookfield APS & Buyers Guide
              </button>
            </a> -->
        </b-col>
      </b-row>

      <!-- First House Section -->
      <!-- Commented out because models currently sold out and this looks like its floating without content -->
      <b-row class="background--white pb-30">
        <b-col md="10" offset-md="1" class="text-center">
          <b-row>
            <h2 class="home-container-title bf-lightblue" id="viewtownsdesigns">
              13' Townhomes
            </h2>
            <b-col
              v-for="home in brookfield_13towns"
              :key="home.homeTitle"
              xl="4"
              md="6"
              lg="6"
              sm="6"
              class="px-2 my-2 home-photo"
            >
              <a target="_blank" :href="home.homeSitePlanPDF">
                <b-img :src="home.homePhoto" fluid />
                <div class="home-info bf-lightblue">
                  <div>
                    <h1>{{ home.homeTitle }}</h1>
                    <p>
                      <span
                        v-for="(elevation, idx) in home.homeElevation"
                        :key="idx"
                      >
                        {{ elevation }}
                      </span>
                    </p>
                  </div>
                  <div>
                    <b-img src="/img/icons/area.png" width="30" />
                  </div>
                </div>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!--  -->
      <b-row class="background--white pb-30">
        <b-col md="10" offset-md="1" class="text-center">
          <b-row>
            <h2 class="home-container-title bf-purple" id="viewtownsdesigns">
              20' Townhomes
            </h2>
            <b-col
              v-for="home in brookfield_20towns"
              :key="home.homeTitle"
              xl="4"
              md="6"
              lg="6"
              sm="6"
              class="px-2 my-2 home-photo"
            >
              <a target="_blank" :href="home.homeSitePlanPDF">
                <b-img :src="home.homePhoto" fluid />
                <div class="home-info bf-purple">
                  <div>
                    <h1>{{ home.homeTitle }}</h1>
                    <p>
                      <span
                        v-for="(elevation, idx) in home.homeElevation"
                        :key="idx"
                      >
                        {{ elevation }}
                      </span>
                    </p>
                  </div>
                  <div>
                    <b-img src="/img/icons/area.png" width="30" />
                  </div>
                </div>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!--  -->
      <b-row class="background--white pb-30">
        <b-col md="10" offset-md="1" class="text-center">
          <b-row>
            <h2 class="home-container-title bf-pink" id="viewtownsdesigns">
              20' Grandview Townhomes
            </h2>
            <b-col
              v-for="home in brookfield_20gv_towns"
              :key="home.homeTitle"
              xl="4"
              md="6"
              lg="6"
              sm="6"
              class="px-2 my-2 home-photo"
            >
              <a target="_blank" :href="home.homeSitePlanPDF">
                <b-img :src="home.homePhoto" fluid />
                <div class="home-info bf-pink">
                  <div>
                    <h1>{{ home.homeTitle }}</h1>
                    <p>
                      <span
                        v-for="(elevation, idx) in home.homeElevation"
                        :key="idx"
                      >
                        {{ elevation }}
                      </span>
                    </p>
                  </div>
                  <div>
                    <b-img src="/img/icons/area.png" width="30" />
                  </div>
                </div>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- Second House Section -->
      <!-- Commented out because models currently sold out and this looks like its floating without content -->
      <!-- <b-row class="background--white pb-30">
        <b-col md="10" offset-md="1" class="text-center">
          <b-row>
            <h2 class="home-container-title yellow" id="view30designs">
              30' Detached
            </h2>
            <b-col
              v-for="home in brookfield30"
              :key="home.homeTitle"
              xl="4"
              md="6"
              lg="6"
              sm="6"
              class="px-2 my-2 home-photo"
            >
              <a target="_blank" :href="home.homeSitePlanPDF">
                <b-img :src="home.homePhoto" fluid />
                <div class="home-info yellow">
                  <div>
                    <h1>{{ home.homeTitle }}</h1>
                    <p>
                      <span
                        v-for="(elevation, idx2) in home.homeElevation"
                        :key="idx2"
                      >
                        {{ elevation }}
                      </span>
                    </p>
                  </div>
                  <div>
                    <b-img src="/img/icons/area.png" width="30" />
                  </div>
                </div>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row> -->

      <!--  Third House Section -->
      <!-- <b-row class="background--white pb-30">
        <b-col md="10" offset-md="1" class="text-center">
          <b-row>
            <h2 class="home-container-title orange" id="view36designs">
              36' Detached
            </h2>
            <b-col
              v-for="home in brookfield36"
              :key="home.homeTitle"
              xl="4"
              md="6"
              lg="6"
              sm="6"
              class="px-2 my-2 home-photo"
            >
              <a target="_blank" :href="home.homeSitePlanPDF">
                <b-img :src="home.homePhoto" fluid />
                <div class="home-info orange">
                  <div>
                    <h1>{{ home.homeTitle }}</h1>
                    <p>
                      <span
                        v-for="(elevation, idx3) in home.homeElevation"
                        :key="idx3"
                      >
                        {{ elevation }}
                      </span>
                    </p>
                  </div>
                  <div>
                    <b-img src="/img/icons/area.png" width="30" />
                  </div>
                </div>
              </a>
            </b-col>
          </b-row>
        </b-col>
      </b-row> -->

      <!--  Fourth House Section -->
      <!-- <b-row class="background--white pb-30">
        <b-col md="10" offset-md="1" class="text-center">
          <b-row>
            <h2 class="home-container-title green" id="view43designs">
              43' Detached
            </h2>
            <b-col v-for="home in brookfield43" :key="home.homeTitle" xl="4" md="6" lg="6" sm="6" class="px-2 my-2 home-photo">
              <a target="_blank" :href="home.homeSitePlanPDF">
                <b-img :src="home.homePhoto" fluid />
                <div class="home-info green">
                    <div>
                        <h1>{{ home.homeTitle }}</h1>
                        <p>
                        <span v-for="(elevation, idx3) in home.homeElevation" :key="idx3">
                            {{ elevation }}
                        </span>
                        </p>
                    </div>
                    <div>
                        <b-img src="/img/icons/area.png" width="30" />
                    </div>
                </div>
              </a>
            </b-col>
          </b-row>

        </b-col>
      </b-row> -->
    </div>
  </b-container>
</template>

<script>
import BrookfieldNewreleaseBanner from "@/components/BrookfieldNewreleaseBanner";
export default {
  // components:{
  //   BrookfieldNewreleaseBanner
  // },
  data() {
    return {
      brookfield_13towns: [
        {
          homeTitle: "Whitevale",
          homeElevation: [
            "style a1 1710 sq ft. | ",
            "style a2 & a3 1770 sq ft. | ",
            "style b1 1730 sq ft. | ",
            "style b2 & b3 1760 sq ft."
          ],
          homePhoto: "/img/houses/brookfield/13/ns-bf-towns-13.jpg",
          homeSize: "",
          homeSitePlanPDF:
            "/files/brookfield/floorplans/13-towns/ns-bf-13-towns-whitevale.pdf"
        },
        {
          homeTitle: "Claremont",
          homeElevation: ["style a1 1890 sq ft. | ", "style b1 1880 sq ft. | "],
          homePhoto: "/img/houses/brookfield/13/ns-bf-towns-13.jpg",
          homeSize: "",
          homeSitePlanPDF:
            "/files/brookfield/floorplans/13-towns/ns-bf-13-towns-claremont.pdf"
        }
      ],
      brookfield_20towns: [
        {
          homeTitle: "Altona",
          homeElevation: [
            "style b1 & b2 1470 sq ft. | ",
            "style c 1480 sq ft."
          ],
          homePhoto: "/img/houses/brookfield/20-towns/ns-bf-towns-20.jpg",
          homeSize: "",
          homeSitePlanPDF:
            "/files/brookfield/floorplans/20-towns/ns-bf-20-towns-altona.pdf"
        },
        {
          homeTitle: "Glendale",
          homeElevation: [
            "style b1 & c1 1630 sq ft. | ",
            "style b2 1610 sq ft."
          ],
          homePhoto: "/img/houses/brookfield/20-towns/ns-bf-towns-20.jpg",
          homeSize: "",
          homeSitePlanPDF:
            "/files/brookfield/floorplans/20-towns/ns-bf-20-towns-glendale.pdf"
        },
        {
          homeTitle: "Denmar",
          homeElevation: ["style b1 & c1 1850 sq ft. "],
          homePhoto: "/img/houses/brookfield/20-towns/ns-bf-towns-20.jpg",
          homeSize: "",
          homeSitePlanPDF:
            "/files/brookfield/floorplans/20-towns/ns-bf-20-towns-denmar.pdf"
        }
      ],
      brookfield_20gv_towns: [
        {
          homeTitle: "Alderwood",
          homeElevation: ["style b1, b2 & c1 2050 sq ft. "],
          homePhoto: "/img/houses/brookfield/20-gv-towns/ns-bf-20gv-towns.png",
          homeSize: "",
          homeSitePlanPDF:
            "/files/brookfield/floorplans/20-gv-towns/ns-bf-20gv-towns-alderwood.pdf"
        },
        {
          homeTitle: "Brockridge",
          homeElevation: ["style b1, b2, c1 & c2 1780 sq ft."],
          homePhoto: "/img/houses/brookfield/20-gv-towns/ns-bf-20gv-towns.png",
          homeSize: "",
          homeSitePlanPDF:
            "/files/brookfield/floorplans/20-gv-towns/ns-bf-20gv-towns-brockridge.pdf"
        }
      ],
      brookfield30: [
        // {
        //   homeTitle: "Kinsmen",
        //   homeElevation: ["style a & b & c 1630 sq ft."],
        //   homePhoto: "/img/houses/30/30-4-A.jpg",
        //   homeSize: "",
        //   homeSitePlanPDF: "/files/brookfield-siteplan/30/Kinsmen.pdf"
        // },
        // {
        //   "homeTitle": "Pinegrove",
        //   "homeElevation": [
        //     "style a 1800 sq ft. | ",
        //     "style b & c 1810 sq ft.",
        //   ],
        //   "homePhoto": "/img/houses/30/30-2-B.jpg",
        //   "homeSize": "",
        //   "homeSitePlanPDF": "/files/brookfield-siteplan/30/Pinegrove.pdf"
        // },
        // {
        //   homeTitle: "Forestbrook",
        //   homeElevation: ["style a 1800 sq ft. | ", "style b & c 1810 sq ft."],
        //   homePhoto: "/img/houses/30/30-1-A.png",
        //   homeSize: "",
        //   homeSitePlanPDF: "/files/brookfield-siteplan/30/Forestbrook.pdf"
        // },
        // {
        //   homeTitle: "Clearside",
        //   homeElevation: ["style a 2090 sq ft. | ", "style b, c 2100 sq ft."],
        //   homePhoto: "/img/houses/30/30-5-A.jpg",
        //   homeSize: "",
        //   homeSitePlanPDF: "/files/brookfield-siteplan/30/Clearside.pdf"
        // },
        // {
        //   "homeTitle": "Woodland",
        //   "homeElevation": [
        //     // "style a, b, c & d 2240 sq ft."
        //     "style a 2240 sq ft."
        //   ],
        //   "homePhoto": "/img/houses/30/Woodland-1.png",
        //   "homeSize": "",
        //   "homeSitePlanPDF": "/files/brookfield-siteplan/30/Woodland.pdf"
        // }
      ],
      brookfield36: [
        {
          homeTitle: "Woodsmere",
          // homeElevation: ["style a & c 2030 sq ft. | ", "style b 2070 sq ft."],
          homeElevation: ["style a 2030 sq ft."],
          homePhoto: "/img/houses/36/36-1-A.jpg",
          homeSize: "",
          homeSitePlanPDF: "/files/brookfield-siteplan/36/Woodsmere.pdf"
        },
        {
          homeTitle: "Liverpool",
          homeElevation: [
            // "style a 2130 sq ft. | ",
            // "style b 2160 sq ft. | ",
            "style c 2120 sq ft."
          ],
          homePhoto: "/img/houses/36/36-4-A.png",
          homeSize: "",
          homeSitePlanPDF: "/files/brookfield-siteplan/36/Liverpool.pdf"
        },
        {
          homeTitle: "Bayridge",
          homeElevation: ["style a, b, c 2190 sq ft."],
          homePhoto: "/img/houses/36/36-4-B.png",
          homeSize: "",
          homeSitePlanPDF: "/files/brookfield-siteplan/36/Bayridge.pdf"
        },
        {
          homeTitle: "Amberlea",
          homeElevation: [
            "style a, b, d 2540 sq ft. | ",
            "style c 2530 sq ft."
          ],
          homePhoto: "/img/houses/36/36-4-C.png",
          homeSize: "",
          homeSitePlanPDF: "/files/brookfield-siteplan/36/Amberlea.pdf"
        },
        {
          homeTitle: "Dunbarton",
          homeElevation: [
            // "style a, c, d 2610 sq ft. | ",
            "style c 2610 sq ft."
            // "style b 2600 sq ft."
          ],
          // homePhoto: "/img/houses/36/36-5-B.png",
          homePhoto: "/img/houses/36/Dunbarton-1.png",
          homeSize: "",
          homeSitePlanPDF: "/files/brookfield-siteplan/36/Dunbarton.pdf"
        }
        // {
        //   homeTitle: "Frenchman",
        //   homeElevation: ["elev a 2766 sq ft."],
        //   homePhoto: "/img/houses/36/36-4-A.png",
        //   homeSize: "",
        //   homeSitePlanPDF: "/files/brookfield-siteplan/36/Frenchman.pdf"
        // },
        // {
        //   homeTitle: "Southcott",
        //   // homeElevation: ["elev a 2766 sq ft."],
        //   homeElevation: ["style c 2370 sq ft."],
        //   // homePhoto: "/img/houses/36/36-4-A.png",
        //   homePhoto: "/img/houses/36/Southcott-1.png",
        //   homeSize: "",
        //   homeSitePlanPDF: "/files/brookfield-siteplan/36/Southcott.pdf"
        // }
      ],
      brookfield43: [
        // {
        //   "homeTitle": "Rosebank",
        //   "homeElevation": [
        //      "style a 3070 sq ft. | ",
        //       "style b 3100 sq ft."
        //   ],
        //   "homePhoto": "/img/houses/43/Rosebank.jpg",
        //   "homeSize": "",
        //   "homeSitePlanPDF": "/files/brookfield-siteplan/43/Rosebank.pdf"
        // },
        // {
        //   "homeTitle": "Rougemount",
        //   "homeElevation": [
        //     "style a 3100 sq ft."
        //   ],
        //   "homePhoto": "/img/houses/43/Rougemount.jpg",
        //   "homeSize": "",
        //   "homeSitePlanPDF": "/files/brookfield-siteplan/43/Rougemount.pdf"
        // }
      ],
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 10000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              arrows: false
            }
          }
        ]
      },
      form: {
        sourceQuery: ""
      }
    };
  },
  mounted() {
    this.$root.layout.methods.triggerViewPortAnimation();
    this.getPageQuery();
  },
  methods: {
    getPageQuery() {
      this.form.sourceQuery = localStorage.getItem("sourceQuery");
    }
  },
  transition: {
    mode: "out-in",
    css: false,
    appear: true,
    enter(el, done) {
      done();
    },
    leave(el, done) {
      done();
    }
  }
};
</script>

<style lang="scss">
.highlight-container {
  @media screen and (max-width: 1920px) and (min-width: 1024px) {
    padding-right: 0px;
    padding-left: 0px;
  }
}
.slider-br {
  padding-top: 20px;
}
.slider-br {
  .slick-next {
    z-index: 4;
    right: 25px;
    background: url("/img/icons/arrow-next.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right;
    width: 30px;
    height: 30px;
    &:before {
      content: "";
    }
    &:hover {
      background: url("/img/icons/arrow-next.png");
      background-repeat: no-repeat;
      background-size: contain;
      background-position: right;
    }
  }
  .slick-prev {
    z-index: 4;
    left: 25px;
    background: url("/img/icons/arrow-prev.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: left;
    width: 30px;
    height: 30px;
    &:before {
      content: "";
    }
    &:hover {
      background: url("/img/icons/arrow-prev.png");
      background-repeat: no-repeat;
      background-size: contain;
      background-position: left;
    }
  }
}
</style>
